import React, { useEffect, useState } from "react";
import Styles from "./ActionWithReasonModal.module.scss";
import { Modal, Space, Text, Button, Input } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";

const BlockUserModalStyles = {
  changed: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
  },
  readOnlyStyle: {
    fontSize: variables.fontSizeNormal,
  },
  changedSuccess: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
    textAlign: variables.alignCenter,
    color: variables.textDefault,
    lineHeight: variables.lineHeightXxlarge,
    display: variables.dBlock,
  },
  BlockButton: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    flex: 1,
    textTransform: "capitalize",
  },
  CancelButton: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    flex: 1,
    border: `1px solid ${variables.grey4}`,
  },
  modalContent: { all: variables.unset, width: variables.fullWidth },
  modalMaskStyle: {
    backdropFilter: variables.highBlur,
    background: variables.blurBackground,
  },
  btnContainer: { display: variables.dFlex, gap: variables.gapSmall },
  textarea: {
    width: variables.fullWidth,
    padding: variables.paddingSmallest,
    fontSize: variables.fontSizeNormal,
  },
  centerImg: {
    display: variables.dFlex,
    justifyContent: variables.alignCenter,
    position: "relative",
  },
  cross: {
    position: "absolute",
    right: "0",
    top: "0",
    height: variables.iconHeightLarge,
    width: variables.iconWidthLarge,
    cursor: "pointer",
  },
  formHelperText: {
    color: variables.errorColor,
    fontSize: variables.fontSizeSmallest,
  },
};

export default function ActionWithReasonModal({
  open,
  onClose,
  onSubmit,
  title,
  placeholder,
  buttonText,
  message,
  isBlock = true,
  readOnlyRemark,
}) {
  const [remark, setRemark] = useState("");
  const [disabled, setDisabled] = useState(false);
  const intl = useIntl();
  const onFormSubmit = (e) => {
    e.preventDefault();
    setDisabled(true);
    onSubmit(remark, setDisabled);
  };

  useEffect(() => {
    if (message) setRemark(message);
    return () => setRemark("");
  }, [message, readOnlyRemark]);

  return (
    <Modal
      maskClosable={false}
      maskStyle={BlockUserModalStyles.modalMaskStyle}
      className={Styles["edged-modal"]}
      centered
      open={open}
      closable={false}
      footer={null}
      width={400}
    >
      <form onSubmit={onFormSubmit}>
        <Space
          direction="vertical"
          align="center"
          style={BlockUserModalStyles.modalContent}
        >
          <div style={BlockUserModalStyles.centerImg}>
            <img
              src={isBlock ? "/icons/Blockuser.svg" : "/icons/unblock.svg"}
              alt="block-user"
            />
            <img
              style={BlockUserModalStyles.cross}
              src={"/icons/close.svg"}
              alt="block-user"
              onClick={onClose}
            />
          </div>
          <Text style={BlockUserModalStyles.changedSuccess}>{title}</Text>
          {isBlock && !readOnlyRemark && (
            <div>
              <Input.TextArea
                required={true}
                style={BlockUserModalStyles.textarea}
                rows={3}
                placeholder={getLocalizedMessage(intl, placeholder)}
                onChange={(e) => {
                  e.preventDefault();
                  if (e.target.value.length > 100) {
                    return;
                  }
                  setRemark(e.target.value);
                }}
                value={remark}
              />
              <Text style={BlockUserModalStyles.formHelperText}>
                {getLocalizedMessage(intl, "blockUser.modal.maxChar100")}
              </Text>
            </div>
          )}
          {readOnlyRemark && message && (
            <Text style={BlockUserModalStyles.readOnlyStyle}>
              <span
                style={{ color: variables.textDefault, fontWeight: "bold" }}
              >
                {getLocalizedMessage(
                  intl,
                  "auditListing.action.markOnHoldReasonLabel"
                )}
                &nbsp;
              </span>
              {remark}
            </Text>
          )}
          <div style={BlockUserModalStyles.btnContainer}>
            <Button
              style={BlockUserModalStyles.CancelButton}
              icon={null}
              type="text"
              onClick={onClose}
            >
              {getLocalizedMessage(intl, "button.text.cancel")}
            </Button>
            <Button
              style={{
                ...BlockUserModalStyles.BlockButton,
                ...(!isBlock && { backgroundColor: variables.successGreen }),
              }}
              icon={null}
              disabled={disabled}
              htmlType="submit"
            >
              {getLocalizedMessage(intl, buttonText)}
            </Button>
          </div>
        </Space>
      </form>
    </Modal>
  );
}
